import { Type } from 'class-transformer';
import { BaseEntity } from '@models';
import { Simulation } from '@services/simulation';
import { Organization } from '@services/organization';
import { QuotationItem } from '@services/quotation-item';

export class Quotation extends BaseEntity {
	name: string;
	description: string;
	country: string;
	currency: string;
	price: number;
	organizationId?: string;

	@Type(() => Organization)
	organization: Organization;

	@Type(() => QuotationItem)
	quotationItems: QuotationItem[];

	simulationId: string;

	@Type(() => Simulation)
	simulation?: Simulation;
}
